export default [
  {
    path: '/roadmaps',
    name: 'roadmap-list',
    props: true,
    component: () => import('@/views/roadmaps/Index.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Run sheets',
      pageDesc: 'Gestion centralisée des run sheets logistiques. Filtrez, consultez et validez les tournées pour une traçabilité optimale des livraisons.',
      breadcrumb: [
        {
          text: 'Run sheets',
          to: { name: 'roadmap-list' },
        },
        {
          text: 'Liste',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Liste des run sheets logistiques',
        description: 'Page accessible pour la gestion, la recherche et la validation des run sheets. Utilisez les filtres et les actions pour chaque tournée.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/roadmaps/create',
    name: 'roadmap-add',
    props: true,
    component: () => import('@/views/roadmaps/Create.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Créer une run sheet',
      pageDesc: 'Créez une run sheet logistique en sélectionnant le dépôt, le livreur, la voiture et les colis à livrer. Assurez la traçabilité et la conformité des tournées.',
      breadcrumb: [
        {
          text: 'Run sheets',
          to: { name: 'roadmap-list' },
        },
        {
          text: 'Créer',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Formulaire de création de run sheet logistique',
        description: 'Sélectionnez le dépôt, le livreur, la voiture et les colis à livrer. Tous les champs sont obligatoires pour garantir la traçabilité.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    admin: true,
    path: '/roadmaps/edit/:id',
    name: 'roadmap-edit',
    props: true,
    component: () => import('@/views/roadmaps/Edit.vue'),
    meta: {
      requireLogin: true,
      pageTitle: 'Modifier une run sheet',
      pageDesc: 'Modifiez les informations de la run sheet logistique, ajoutez ou retirez des colis, changez de livreur ou de véhicule, et assurez la conformité des tournées.',
      breadcrumb: [
        {
          text: 'Run sheets',
          to: { name: 'roadmap-list' },
        },
        {
          text: 'Modifier',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Formulaire de modification de run sheet logistique',
        description: 'Modifiez les informations, ajoutez ou retirez des colis, changez de livreur ou de véhicule. Tous les champs sont obligatoires pour garantir la traçabilité.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/roadmaps/Show/:id',
    name: 'roadmap-show',
    props: true,
    component: () => import('@/views/roadmaps/Show.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageDesc: 'Consultez le détail, l’historique et le statut de la run sheet logistique sélectionnée. Imprimez ou validez la tournée selon vos droits.',
      breadcrumb: [
        {
          text: 'Run sheets',
          to: { name: 'roadmap-list' },
        },
        {
          text: 'Détail',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Détail de la run sheet logistique',
        description: 'Page détaillée de la run sheet logistique. Accédez à l’historique, aux colis concernés et aux actions disponibles.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
  {
    path: '/roadmaps/show-2/:id',
    name: 'roadmap-show-2',
    props: true,
    component: () => import('@/views/roadmaps/Show2.vue'),
    meta: {
      admin: true,
      requireLogin: true,
      pageTitle: 'Run sheet (moderne)',
      pageDesc: 'Consultez la run sheet avec une interface moderne et améliorée.',
      breadcrumb: [
        {
          text: 'Run sheets',
          to: { name: 'roadmap-list' },
        },
        {
          text: 'Détail moderne',
          active: true,
        },
      ],
      accessibility: {
        ariaLabel: 'Détail moderne de la run sheet logistique',
        description: 'Page moderne et accessible pour consulter les détails de la run sheet logistique.',
      },
      roles: ['admin', 'superadmin', 'manager', 'warehouse_operator'],
    },
  },
]
